<template>
</template>
<script>
    import ButtonWidthMixin from "../../../author/pagesbuilder/mixins/ButtonWidthMixin";
    import HamburgerOptionsMixin from "../../../author/pagesbuilder/mixins/HamburgerOptionsMixin";

    export default {
        name: "ButtonElement",
        mixins: [
            ButtonWidthMixin,
            HamburgerOptionsMixin
        ],
        data() {
            return {
                elementType: "button",
                givesContextToChildren: true,
            }
        },
        computed: {
            getDefaultDataStructure () {
                return {
                    elementType: this.elementType,
                    elementId: this.elementId,
                    styles: null,
                    linkData: {},
                    size: "",
                    responsiveButtonWidthClass: {
                        'desktop': '',
                        'tablet-portrait': '',
                        'tablet-landscape': '',
                        'smartphone-portrait': '',
                        'smartphone-landscape': ''
                    },
                    itemVisibilitySettings: null
                }
            },
        }
    }
</script>
